import React, { useEffect, useState, useCallback } from "react";
import { useAppSelector } from '../../../Store/hooks';
import { SelectStatus } from '../../../Store/Selectors'
import { stageList } from "../../../Models/Status";
import { sortCenterLogo, deliveredLogo, returnToSenderLogo, inDeliveryLogo, inDepotLogo } from '../../../Assets/index';
import { StepIconProps } from "@mui/material/StepIcon";
import "./CustomStepComponent.scss";

export const CustomStepComponent: React.FC<StepIconProps> = (props): JSX.Element => {
  const [iconClass, setIconClass] = useState<string>("");
  const { active, completed } = props;

  const statusState = useAppSelector(SelectStatus);
  const index = props.icon as number;
  const deliveryFailed = statusState.currentStatus?.stage === stageList.Unzustellbar;

  const setClass = useCallback(() => {
    if (deliveryFailed && index === 4) return setIconClass("custom-label-failed");
    if (active) return setIconClass("custom-label-active");
    if (completed) return setIconClass("custom-label-completed");
    return setIconClass("");
  }, [index, deliveryFailed, active, completed]);

  useEffect(() => {
    if (active || completed) {
      setTimeout(() => { setClass() }, 150 * index);
    } else {
      setClass();
    }
  }, [active, completed, index, setClass]);

  const icons: { [index: string]: React.ReactElement } = {
    1: <img height='100%' title="Sortierzentrum" alt="Sortierzentrum" src={sortCenterLogo} />,
    2: <img height='100%' title="Zustelldepot" alt="Zustelldepot" src={inDepotLogo} />,
    3: <img height='100%' title="In Zustellung" alt="In Zustellung" src={inDeliveryLogo} />,
    4: deliveryFailed ?
      <img height='100%' title="Unzustellbar" alt="Unzustellbar" src={returnToSenderLogo} /> :
      <img height='100%' title="Zugestellt" alt="Zugestellt" src={deliveredLogo} />,
  };

  return (
    <div className={`custom-label ` + iconClass}>
      {icons[String(props.icon)]}
    </div>
  );
};
